import { licenseModule } from '@/store/license/module'

const getMostRecentLicense = () => {
    const licenses = [ ...licenseModule.state.licenses ]
    const sortedLicenses = licenses.sort((a, b) => {
        const aRedeemedDate = a.redeemedDate?.iso ? new Date(a.redeemedDate.iso) : undefined
        const bRedeemedDate = b.redeemedDate?.iso ? new Date(b.redeemedDate.iso) : undefined
        if (aRedeemedDate && bRedeemedDate) {
            return bRedeemedDate.getTime() - aRedeemedDate.getTime()
        } else if (!aRedeemedDate && bRedeemedDate) {
            return 1
        } else if (aRedeemedDate && !bRedeemedDate) {
            return -1
        } else {
            return 0
        }
    })
    return sortedLicenses[0]
}

export default {
    getMostRecentLicense,
}
